<template>
  <div class="footer_wrapper">
    <footer>
      <router-link to="/" class="logo"></router-link>
      <Menu :lang="lang"></Menu>
    </footer>
  </div>
</template>

<script>
import Menu from "./Menu";
export default {
  name: 'Footer',
  components: {Menu},
  props: {
    lang: String
  }
}
</script>

<style>

  footer .logo{
    position: absolute;
    display: block;
    background: url("../assets/img/logo_footer.png") no-repeat;
    width: 132px;
    height: 38px;
    left: 0;
    top: 20px;
  }

  footer .menu_wrapper{
    text-align: center;
    padding-top: 30px;
  }

  footer .menu a{
    color: #fdf6e3;
    text-decoration: none;
    text-transform: uppercase;
    font-family: Arial, Helvetica, sans-serif;
  }
  footer .menu a:hover{
    text-shadow: 2px 2px 6px rgba(50, 50, 50, 1);
  }
  footer .menu > span{
    color: #fdf6e3;
    padding: 0 10px;
  }
</style>
